module.exports = __webpack_public_path__ + "static/media/10.bdbfc671.png";